module.exports = __webpack_public_path__ + "static/media/office7.994e8a46.jpg";